export enum NotificationPriority {
  Standard = 'standard',
  High = 'high'
}
